import Class from '@/Class';
import type ColumnFactory from '@/Factories/ColumnFactory';

export default class ColumnFactoryTuple extends Class {

    public value: any;
    public factory: ColumnFactory;

    constructor(factory: ColumnFactory) {
        super();

        this.value = factory.getValue();
        this.factory = factory;
        this.isDisposable = true;
    }
}